import type { TriggerRenderer } from "../types";
import { renderTriggerRenderer } from "./common";

export const onBuildTriggerRenderer: TriggerRenderer = renderTriggerRenderer;
